export default {
  label: 'Respondentes',
  placeholder: 'Sem respondente',
  indifferent: 'Indiferente',
  other: 'outro',
  others: 'outros',
};
